"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Thumbnail_Wrapper_1 = __importDefault(require("./Thumbnail.Wrapper"));
require("./Thumbnail.css");
function Button(_a) {
    var children = _a.children, className = _a.className, aspectRatio = _a.aspectRatio, width = _a.width, ariaLabel = _a.ariaLabel, disabled = _a.disabled, onClick = _a.onClick;
    var buttonClass = (0, classnames_1.default)("nimbus--thumbnail-button", className);
    return (React.createElement(Thumbnail_Wrapper_1.default, { aspectRatio: aspectRatio, width: width },
        React.createElement("button", { "aria-label": ariaLabel, title: ariaLabel, type: "button", onClick: onClick, disabled: disabled, className: buttonClass }, children)));
}
exports.default = Button;
//# sourceMappingURL=Thumbnail.Button.js.map